import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CommonStatCard from "../../../../components/pt/pt-flow-new/CommonStatCard";
import ReactVortoxSpinner from "../../../../components/common-components/ReactVortoxSpinner";

const CheckinsStatCards = () => {
  const { checkinsStatLoading, checkinsStatError, checkinsStat } = useSelector(
    (state) => state.features
  );

  const iniDatas = {
    allStats: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const EXCLUDED_KEYS = [" "];

  const STAT_ORDER = [
    "total_member",
    "total_receptionist",
    "total_trainer",
    "total_housekeeping",
    "total_guest",
    "total_gym",
    "total_admin",
  ];

  const getCardLabel = (key) => {
    switch (key) {
      case "total_receptionist":
        return "Sales Executives";
      default:
        return key.replace(/total_/i, "").replace(/_/g, " ");
    }
  };

  const sortedCards =
    allDatas.allStats &&
    Object?.entries(allDatas.allStats)
      ?.sort(([keyA], [keyB]) => {
        const indexA = STAT_ORDER.indexOf(keyA);
        const indexB = STAT_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          {!EXCLUDED_KEYS.includes(key) && (
            <CommonStatCard
              tagName={key}
              cardLabel={getCardLabel(key)}
              value={value || 0}
            />
          )}
        </React.Fragment>
      ));

  useEffect(() => {
    if (
      !checkinsStatLoading &&
      !checkinsStatError &&
      checkinsStat?.status &&
      checkinsStat?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allStats: checkinsStat.data || {},
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [checkinsStatLoading, checkinsStatError, checkinsStat]);

  return (
    <div className="cards-container cards-grid-container grid-5 pt-flow-new m-0 mb-4">
      {checkinsStatLoading ? <ReactVortoxSpinner /> : sortedCards}
    </div>
  );
};

export default CheckinsStatCards;